import { gql } from "@apollo/client"

export const LIST_CUSTOM_SADDLE_ORDER_REQUESTS = gql`
 query ListCustomSaddleOrderRequests(
  $status: CustomSaddleOrderStatus
  $manufacturerId: ID
  $shippingDestination: ShippingDestination
  $limit: Int
  $nextToken: String
) {
  listCustomSaddleOrderRequests(
    status: $status
    manufacturerId: $manufacturerId
    shippingDestination: $shippingDestination
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      manufacturerId
      manufacturerName
      userId
      horseName
      status
      gulletWidth 
      barAngle
      adminNotes
      orderId
     customOrderStatus{
        status
        timestamp
        operatorUserId
        assignedUserId
        operatorUser{
          id
          name
          type
          brand
        }
        assignedUser{
          id
          name
          type
          brand
        }
      }
      saddleSpecs {
        seatSize
        discipline
      }
      shippingAddress {
        city
        state
        country
      }
      createdAt
    }
    nextToken
    count
  }
}
`
